const styles = theme => ({
  root: {
    display: 'flex',
    gap: 8,
  },
})

export default styles
